
export default function () {
  // console.log(app);
}



// WEBPACK FOOTER //
// ./src/app/module/index.js